export default __webpack_public_path__ + "static/media/dfsforecast-back-2021.dbf9f66d.png";